import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class FormlyTranslateExtension {
  constructor(private translate: TranslateService) {}
  prePopulate(field: FormlyFieldConfig): void {
    const to = field.templateOptions || {};
    if (!to.translate || to._translated) {
      return;
    }

    to._translated = true;

    if (to.label != null) {
      const label$ = this.translate.stream(to.label);

      let translate$: Observable<string>;
      if (translate$! == null) translate$ = label$;

      field.expressionProperties = {
        ...(field.expressionProperties || {}),
        'templateOptions.label': translate$,
      };
    }

    if (to.placeholder != null) {
      const placeholder$ = this.translate.stream(to.placeholder);

      let translate$: Observable<string>;
      if (translate$! == null) translate$ = placeholder$;

      field.expressionProperties = {
        ...(field.expressionProperties || {}),
        'templateOptions.placeholder': translate$,
      };
    }

    if (to.description != null) {
      const description$ = this.translate.stream(to.description);

      let translate$: Observable<string>;
      if (translate$! == null) translate$ = description$;

      field.expressionProperties = {
        ...(field.expressionProperties || {}),
        'templateOptions.description': translate$,
      };
    }

    if (to.selectAllOption != null) {
      field.expressionProperties = {
        ...(field.expressionProperties || {}),
        'templateOptions.selectAllOption': this.translate.stream(
          to.selectAllOption
        ),
      };
    }

    if (Array.isArray(to.options)) {
      const options = to.options;

      if (!options.length) return;

      to.options = this.translate.stream(options.map(o => o.label)).pipe(
        map(labels => {
          return options.map(o => ({
            ...o,
            label: labels[o.label],
          }));
        })
      );
    }
  }
}

export function registerFormlyTranslateExtension(
  translate: TranslateService
): any {
  return {
    validationMessages: [
      {
        name: 'required',
        message(): any {
          return translate.stream(_('FORM.VALIDATION.REQUIRED'));
        },
      },
      {
        name: 'minLength',
        message(): any {
          return translate.stream(_('FORM.VALIDATION.MIN_LENGTH'));
        },
      },
    ],
    extensions: [
      {
        name: 'translate',
        extension: new FormlyTranslateExtension(translate),
      },
    ],
  };
}
